<template>
  <div class="comment-cell">
    <div class="d-flex d-flex--middle d-flex--justify user">
      <div class="d-flex d-flex__item d-flex--middle">
        <div
          class="avatar"
          :style="{ backgroundImage: `url(${data.wxProfilePhoto})` }"
        ></div>
        <div class="name">{{ data.userName }}</div>
        <div class="time">{{ data.updateDate | date }}</div>
      </div>
      <div>
        <StarScore :value="score" />
      </div>
    </div>
    <div>{{ data.content }}</div>
  </div>
</template>

<script>
import StarScore from "@/components/StarScore";
import dayjs from "dayjs";
export default {
  props: {
    data: Object,
  },
  filters: {
    date(val) {
      return dayjs(val).format("YYYY-MM-DD HH:mm");
    },
  },
  computed: {
    score() {
      return +this.data.score / 2;
    },
  },
  components: { StarScore },
};
</script>

<style lang="scss" scoped>
.comment-cell {
  padding: 30px 0;
  position: relative;

  &:not(:last-child) {
    &::after {
      @include border-bottom-1;
      background: #dddddd;
    }
  }
}
.user {
  margin-bottom: 30px;
  line-height: 1;
  .avatar {
    width: 56px;
    height: 56px;
    background: #ccc no-repeat center;
    background-size: cover;
    border-radius: 50%;
    margin-right: 16px;
  }
  .name {
    color: #666;
    font-weight: 500;
    margin-right: 30px;
    max-width: 30%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .time {
    color: #999;
    font-size: 24px;
  }
}
</style>
